import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

import { CallFeedbackFormData } from "../types/call-feedback.schema";

const postFeedback = async (data: CallFeedbackFormData) => {
  const response = await axiosClient.post("/emails/feedback", data);
  return response.data;
};

export function usePostFeedback(
  queryOptions?: UseMutationOptions<void, HttpError, CallFeedbackFormData>,
) {
  return useMutation({
    mutationFn: postFeedback,
    ...queryOptions,
  });
}
